import { render, staticRenderFns } from "./CadastrosGrid.vue?vue&type=template&id=7f1a3a5f&scoped=true"
import script from "./CadastrosGrid.vue?vue&type=script&lang=js"
export * from "./CadastrosGrid.vue?vue&type=script&lang=js"
import style0 from "./CadastrosGrid.vue?vue&type=style&index=0&id=7f1a3a5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1a3a5f",
  null
  
)

export default component.exports